/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';

/**
 * The props for `<SdsIcon />`.
 */
export interface SdsIconProps extends SdsDivProps {
  /**
   * The custom HTML element tag to use.
   */
  customTag?: keyof JSX.IntrinsicElements;

  /**
   * The SVG element to be passed.
   */
  svg: JSX.Element;
}

/**
 * The default prop values for `<SdsIcon />`.
 */
export const sdsIconDefaults = {
  customTag: `div` as keyof JSX.IntrinsicElements,
};
